<template>
  <div class="wrap white-bg mb40">
            <div class="apply-title">校企合作&合作办学</div>
            <div class="cooperate-union">
                <p>校企合作详见<strong>《校企合作手册》</strong></p>
                <p><strong>合作办学标准</strong></p>
                <p>
                    政府、学校、企事业单位新建校舍或将闲置校舍租赁给文都教育用于办学，文都教育投入知识产权、教育品牌、教育教学体系、师资队伍、管理模式。
                </p>
            </div>
        </div>
</template>

<script >
import { defineComponent,ref } from 'vue'
export default defineComponent({
 setup(){
     
     return{
        
     }
 }
})
</script>

<style lang="scss" scoped type="text/scss">
.cooperate-union{
    padding:56px 64px;
    font-size:14px;
    color:#1B1D1F;
    p{
        margin-bottom:16px;
    }
    a{
        color:#1B1D1F;
        font-weight:bold;
    }
}
</style>
